import React from 'react'
import { Tabs } from 'antd'
import { caregiverActivitiesMockData } from './utils/mockdata'
import useActivityFilters from './hooks/useActivityFilters'
import useActivityModal from './hooks/useActivityModal'
import CaregiverHeader from './Components/CaregiverHeader'
import ActivityFilters from './Components/ActivityFilters'
import ActivityTable from './Components/ActivityTable'
import ActivityTimeline from './Components/ActivityTimeline'
import ActivityModal from './Components/ActivityModal'

const { TabPane } = Tabs

const CaregiverActivities = () => {
  // Use custom hooks
  const {
    filterValues,
    filteredData,
    searchText,
    setSearchText,
    caregiverFilter,
    setCaregiverFilter,
    activityTypeFilter,
    setActivityTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  } = useActivityFilters(caregiverActivitiesMockData)

  const { isModalVisible, form, showModal, handleCancel, handleAdd } = useActivityModal()

  // Combine all filter state for passing to components
  const filterState = {
    searchText,
    setSearchText,
    caregiverFilter,
    setCaregiverFilter,
    activityTypeFilter,
    setActivityTypeFilter,
    statusFilter,
    setStatusFilter,
    dateRange,
    setDateRange
  }

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <CaregiverHeader onAddActivity={showModal} />

      {/* Filters */}
      <ActivityFilters filterValues={filterValues} filterState={filterState} />

      {/* Tabs for different views */}
      <Tabs defaultActiveKey='table'>
        <TabPane tab='Table View' key='table'>
          <ActivityTable data={filteredData} />
        </TabPane>

        <TabPane tab='Timeline View' key='timeline'>
          <ActivityTimeline data={filteredData} caregivers={filterValues.caregivers} />
        </TabPane>
      </Tabs>

      {/* Activity Modal */}
      <ActivityModal
        isVisible={isModalVisible}
        onCancel={handleCancel}
        onAdd={handleAdd}
        form={form}
        filterValues={filterValues}
      />
    </div>
  )
}

export default CaregiverActivities
